import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-close-icon',
    templateUrl: './close-icon.component.html',
    styleUrls: ['./close-icon.component.scss']
})
export class CloseIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 24;
    }
}
